import {
    CREATE_CHANNEL_CONTRACT_DIALOG_SHOW,
    CREATE_CHANNEL_CONTRACT_DIALOG_HIDE,
    FETCH_CHANNEL_CONTRACT_AVAILABILITY_IN_PROGRESS,
    FETCH_CHANNEL_CONTRACT_AVAILABILITY_SUCCESS,
    FETCH_CHANNEL_CONTRACT_AVAILABILITY_ERROR,
    CHANNEL_CONTRACT_USER_NAME_SET,
    CHANNEL_CONTRACT_DISPLAY_NAME_SET,
    CHANNEL_CONTRACT_USER_NAME_STATUS_SET,
    FETCH_CHANNEL_CONTRACT_IN_PROGRESS,
    FETCH_CHANNEL_CONTRACT_SUCCESS,
    FETCH_CHANNEL_CONTRACT_ERROR,
    FETCH_CHANNEL_CONTRACT_INFO_IN_PROGRESS,
    FETCH_CHANNEL_CONTRACT_INFO_SUCCESS,
    FETCH_CHANNEL_CONTRACT_INFO_ERROR,
    CHANNEL_CONTRACT_CHANGE_DIALOG_SHOW,
    CHANNEL_CONTRACT_CHANGE_DIALOG_HIDE,
    CHANNEL_CONTRACT_SETTINGS_TAB_SET,
    SETTINGS_CHANNEL_CONTRACT_NAME_SET,
    SETTINGS_CHANNEL_CONTRACT_DESCRIPTION_SET,
    SETTINGS_CHANNEL_CONTRACT_ADDRESS_SET,
    SETTINGS_CHANNEL_CONTRACT_ALLOW_PUBLISHERS_SET,
    SETTINGS_CHANNEL_CONTRACT_IMAGE_SET,
    CHANNEL_CONTRACT_USERNAME_SETTINGS_SET,
    CHANNEL_CONTRACT_SAVE_BUTTON_ENABLE_SET,
    FETCH_CHANNEL_ASSETS_IN_PROGRESS,
    FETCH_CHANNEL_ASSETS_SUCCESS,
    FETCH_CHANNEL_ASSETS_ERROR,
    CHANNEL_ASSETS_TAB_SET,
    CHANNEL_CONTRACT_COLLABORATION_STATUS_SET,
    CHANNEL_CONTRACT_COLLABORATION_VALUE_SET,
    REMOVE_COLLABORATORS_DIALOG_SHOW,
    REMOVE_COLLABORATORS_DIALOG_HIDE,
    ADD_NEW_COLLABORATORS,
    CHANNEL_CONTRACT_ADDRESS_FETCH_IN_PROGRESS,
    CHANNEL_CONTRACT_ADDRESS_FETCH_SUCCESS,
    CHANNEL_CONTRACT_ADDRESS_FETCH_ERROR,
    FETCH_CHANNEL_CONTRACT_IV_IN_PROGRESS,
    FETCH_CHANNEL_CONTRACT_IV_SUCCESS,
    FETCH_CHANNEL_CONTRACT_IV_ERROR,
    IS_V2_CHANNEL_PRESENT,
    SET_CHANNEL_EMPTY,
    SETTINGS_CHANNEL_CONTRACT_BANNER_SET,
    CHANNEL_PAGE_TAB_VALUE_SET,
    CHANNEL_PAGE_SUB_TAB_VALUE_SET,
    FETCH_CHANNEL_CONTRACT_VOD_IN_PROGRESS,
    FETCH_CHANNEL_CONTRACT_VOD_SUCCESS,
    FETCH_CHANNEL_CONTRACT_VOD_ERROR,
    FETCH_CONTRACT_VIDEO_MINTS_IN_PROGRESS,
    FETCH_CONTRACT_VIDEO_MINTS_SUCCESS,
    FETCH_CONTRACT_VIDEO_MINTS_ERROR,
    FETCH_CONTRACT_GATED_IV_IN_PROGRESS,
    FETCH_CONTRACT_GATED_IV_SUCCESS,
    FETCH_CONTRACT_GATED_IV_ERROR,
    FETCH_CONTRACT_VIDEO_DROPS_IN_PROGRESS,
    FETCH_CONTRACT_VIDEO_DROPS_SUCCESS,
    FETCH_CONTRACT_VIDEO_DROPS_ERROR,
    FETCH_CONTRACT_UPCOMING_IV_IN_PROGRESS,
    FETCH_CONTRACT_UPCOMING_IV_SUCCESS,
    FETCH_CONTRACT_UPCOMING_IV_ERROR,
    FETCH_CONTRACT_INTERACTIVE_VIDEOS_IN_PROGRESS,
    FETCH_CONTRACT_INTERACTIVE_VIDEOS_SUCCESS,
    FETCH_CONTRACT_INTERACTIVE_VIDEOS_ERROR,
    SET_VIDEOS_LIST_EMPTY,
    FETCH_CHANNEL_LIVE_STREAMS_IN_PROGRESS,
    FETCH_CHANNEL_LIVE_STREAMS_SUCCESS,
    FETCH_CHANNEL_LIVE_STREAMS_ERROR,
    FETCH_CHANNEL_VIDEOS_STATS_IN_PROGRESS,
    FETCH_CHANNEL_VIDEOS_STATS_SUCCESS,
    FETCH_CHANNEL_VIDEOS_STATS_ERROR,
    SET_CHANNEL_IV_SEARCH,
    DISCARD_CHANGES_DIALOG_HIDE,
    DISCARD_CHANGES_DIALOG_SHOW,
} from '../../constants/channelContract';
import {
    CHANNEL_CONTRACT_ADDRESS_URL,
    urlFetchChannelAssets,
    urlFetchChannelContract,
    urlFetchChannelContractAvailability,
    urlFetchChannelContracts,
    urlFetchChannelContractIV,
    urlFetchChannelContractVODs,
    urlFetchContractInteractiveVideos,
    urlFetchContractVideoMints,
    urlFetchContractGatedIV,
    urlFetchContractVideoDrops,
    urlFetchContractUpcomingIV,
    urlFetchChannelLiveStreams,
    urlChannelVideoStats,
} from '../../constants/restURL';
import Axios from 'axios';
import { handleErrorMessage } from '../../utils/errorMessages';

export const showCreateChannelContractDialog = () => {
    return {
        type: CREATE_CHANNEL_CONTRACT_DIALOG_SHOW,
    };
};

export const hideCreateChannelContractDialog = () => {
    return {
        type: CREATE_CHANNEL_CONTRACT_DIALOG_HIDE,
    };
};

const fetchChannelContractAvailabilityInProgress = () => {
    return {
        type: FETCH_CHANNEL_CONTRACT_AVAILABILITY_IN_PROGRESS,
    };
};

const fetchChannelContractAvailabilitySuccess = (value) => {
    return {
        type: FETCH_CHANNEL_CONTRACT_AVAILABILITY_SUCCESS,
        value,
    };
};

const fetchChannelContractAvailabilityError = (message) => {
    return {
        type: FETCH_CHANNEL_CONTRACT_AVAILABILITY_ERROR,
        message,
    };
};

export const fetchChannelContractAvailability = (address, contractAddress, data, cb) => (dispatch) => {
    dispatch(fetchChannelContractAvailabilityInProgress());

    const url = urlFetchChannelContractAvailability(address, contractAddress);
    Axios.post(url, data, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(fetchChannelContractAvailabilitySuccess(res.data && res.data.result));
            if (cb) {
                cb(res.data && res.data.result);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchChannelContractAvailabilityError(message));
            if (cb) {
                cb(null, message);
            }
        });
};

export const setChannelContractDisplayName = (value) => {
    return {
        type: CHANNEL_CONTRACT_DISPLAY_NAME_SET,
        value,
    };
};

export const setChannelContractUserName = (value) => {
    return {
        type: CHANNEL_CONTRACT_USER_NAME_SET,
        value,
    };
};

export const setChannelContractUserNameStatus = (value) => {
    return {
        type: CHANNEL_CONTRACT_USER_NAME_STATUS_SET,
        value,
    };
};

const fetchChannelContractInProgress = () => {
    return {
        type: FETCH_CHANNEL_CONTRACT_IN_PROGRESS,
    };
};

const fetchChannelContractSuccess = (value, skip, limit, search, total) => {
    return {
        type: FETCH_CHANNEL_CONTRACT_SUCCESS,
        value,
        skip,
        limit,
        search,
        total,
    };
};

const fetchChannelContractError = (message) => {
    return {
        type: FETCH_CHANNEL_CONTRACT_ERROR,
        message,
    };
};

export const fetchChannelContract = (contractAddress, creator, skip, limit, search, cb) => (dispatch) => {
    dispatch(fetchChannelContractInProgress());

    const url = urlFetchChannelContracts(contractAddress, creator, skip, limit, search);
    Axios.get(url, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(fetchChannelContractSuccess(res.data && res.data.result && res.data.result.list,
                skip, limit, search, res && res.data && res.data.result && res.data.result.count));
            if (cb) {
                cb(res.data && res.data.result && res.data.result.list, res && res.data && res.data.result && res.data.result.count);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchChannelContractError(message));
            if (cb) {
                cb(null);
            }
        });
};

const fetchChannelContractInfoInProgress = () => {
    return {
        type: FETCH_CHANNEL_CONTRACT_INFO_IN_PROGRESS,
    };
};

const fetchChannelContractInfoSuccess = (value) => {
    return {
        type: FETCH_CHANNEL_CONTRACT_INFO_SUCCESS,
        value,
    };
};

const fetchChannelContractInfoError = (message) => {
    return {
        type: FETCH_CHANNEL_CONTRACT_INFO_ERROR,
        message,
    };
};

export const fetchChannelContractInfo = (id, address, cb) => (dispatch) => {
    dispatch(fetchChannelContractInfoInProgress());

    const url = urlFetchChannelContract(id, address);
    Axios.get(url, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(fetchChannelContractInfoSuccess(res.data && res.data.result));
            if (cb) {
                cb(res.data && res.data.result);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchChannelContractInfoError(message));
            if (cb) {
                cb(null);
            }
        });
};

export const showChannelContractChangeDialog = () => {
    return {
        type: CHANNEL_CONTRACT_CHANGE_DIALOG_SHOW,
    };
};

export const hideChannelContractChangeDialog = () => {
    return {
        type: CHANNEL_CONTRACT_CHANGE_DIALOG_HIDE,
    };
};

export const setChannelContractSettingsTab = (value) => {
    return {
        type: CHANNEL_CONTRACT_SETTINGS_TAB_SET,
        value,
    };
};

export const setSettingsChannelContractName = (value) => {
    return {
        type: SETTINGS_CHANNEL_CONTRACT_NAME_SET,
        value,
    };
};

export const setSettingsChannelContractDescription = (value, valid) => {
    return {
        type: SETTINGS_CHANNEL_CONTRACT_DESCRIPTION_SET,
        value,
        valid,
    };
};

export const setSettingsChannelContractAddress = (value) => {
    return {
        type: SETTINGS_CHANNEL_CONTRACT_ADDRESS_SET,
        value,
    };
};

export const setSettingsChannelContractAllowPublishers = (value) => {
    return {
        type: SETTINGS_CHANNEL_CONTRACT_ALLOW_PUBLISHERS_SET,
        value,
    };
};

export const setSettingsChannelContractImage = (value) => {
    return {
        type: SETTINGS_CHANNEL_CONTRACT_IMAGE_SET,
        value,
    };
};

export const setSettingsChannelContractBanner = (value) => {
    return {
        type: SETTINGS_CHANNEL_CONTRACT_BANNER_SET,
        value,
    };
};

export const setChannelContractUserNameSettings = (value) => {
    return {
        type: CHANNEL_CONTRACT_USERNAME_SETTINGS_SET,
        value,
    };
};

export const setChannelContractCollaborationStatus = (value, address, role) => {
    return {
        type: CHANNEL_CONTRACT_COLLABORATION_STATUS_SET,
        value,
        address,
        role,
    };
};

export const setChannelContractCollaborationValue = (value) => {
    return {
        type: CHANNEL_CONTRACT_COLLABORATION_VALUE_SET,
        value,
    };
};

export const setNewCollaborators = (value) => {
    return {
        type: ADD_NEW_COLLABORATORS,
        value,
    };
};

export const showRemoveCollaboratorDialog = (value) => {
    return {
        type: REMOVE_COLLABORATORS_DIALOG_SHOW,
        value,
    };
};

export const hideRemoveCollaboratorDialog = () => {
    return {
        type: REMOVE_COLLABORATORS_DIALOG_HIDE,
    };
};

export const setChannelContractSaveButtonEnable = (value) => {
    return {
        type: CHANNEL_CONTRACT_SAVE_BUTTON_ENABLE_SET,
        value,
    };
};

const fetchChannelAssetsInProgress = () => {
    return {
        type: FETCH_CHANNEL_ASSETS_IN_PROGRESS,
    };
};

const fetchChannelAssetsSuccess = (value, skip, limit, total) => {
    return {
        type: FETCH_CHANNEL_ASSETS_SUCCESS,
        value,
        skip,
        limit,
        total,
    };
};

const fetchChannelAssetsError = (message) => {
    return {
        type: FETCH_CHANNEL_ASSETS_ERROR,
        message,
    };
};

export const fetchChannelAssets = (address, id, skip, limit, cb) => (dispatch) => {
    dispatch(fetchChannelAssetsInProgress());

    const url = urlFetchChannelAssets(address, id, skip, limit);
    Axios.get(url, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(fetchChannelAssetsSuccess(res.data && res.data.result && res.data.result.list,
                skip, limit, res && res.data && res.data.result && res.data.result.count));
            if (cb) {
                cb(res.data && res.data.result && res.data.result.list, res && res.data && res.data.result && res.data.result.count);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchChannelAssetsError(message));
            if (cb) {
                cb(null);
            }
        });
};

export const setChannelAssetsTab = (value) => {
    return {
        type: CHANNEL_ASSETS_TAB_SET,
        value,
    };
};

export const channelContractAddressInProgress = () => {
    return {
        type: CHANNEL_CONTRACT_ADDRESS_FETCH_IN_PROGRESS,
    };
};

export const channelContractAddressSuccess = (value, message) => {
    return {
        type: CHANNEL_CONTRACT_ADDRESS_FETCH_SUCCESS,
        value,
        message,
        variant: 'success',
    };
};

export const channelContractAddressError = (message) => {
    return {
        type: CHANNEL_CONTRACT_ADDRESS_FETCH_ERROR,
        message,
    };
};

export const fetchChannelContractAddress = () => (dispatch) => {
    dispatch(channelContractAddressInProgress());

    Axios.get(CHANNEL_CONTRACT_ADDRESS_URL, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(channelContractAddressSuccess(res.data && res.data.result, 'Success'));
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(channelContractAddressError(message));
        });
};

const fetchChannelContractIVInProgress = () => {
    return {
        type: FETCH_CHANNEL_CONTRACT_IV_IN_PROGRESS,
    };
};

const fetchChannelContractIVSuccess = (value, skip, limit, search, total) => {
    return {
        type: FETCH_CHANNEL_CONTRACT_IV_SUCCESS,
        value,
        skip,
        limit,
        search,
        total,
    };
};

const fetchChannelContractIVError = (message) => {
    return {
        type: FETCH_CHANNEL_CONTRACT_IV_ERROR,
        message,
    };
};

export const fetchChannelContractIV = (id, skip, limit, search, cb) => (dispatch) => {
    dispatch(fetchChannelContractIVInProgress());

    const url = urlFetchChannelContractIV(id, skip, limit, search);
    Axios.get(url, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(fetchChannelContractIVSuccess(res.data && res.data.result && res.data.result.list,
                skip, limit, search, res && res.data && res.data.result && res.data.result.count));
            if (cb) {
                cb(res.data && res.data.result && res.data.result.list, res && res.data && res.data.result && res.data.result.count);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchChannelContractIVError(message));
            if (cb) {
                cb(null);
            }
        });
};

const fetchChannelContractVODsInProgress = () => {
    return {
        type: FETCH_CHANNEL_CONTRACT_VOD_IN_PROGRESS,
    };
};

const fetchChannelContractVODsSuccess = (value, skip, limit, search, total) => {
    return {
        type: FETCH_CHANNEL_CONTRACT_VOD_SUCCESS,
        value,
        skip,
        limit,
        search,
        total,
    };
};

const fetchChannelContractVODsError = (message) => {
    return {
        type: FETCH_CHANNEL_CONTRACT_VOD_ERROR,
        message,
    };
};

export const fetchChannelContractVODs = (id, skip, limit, search, cb) => (dispatch) => {
    dispatch(fetchChannelContractVODsInProgress());

    const url = urlFetchChannelContractVODs(id, skip, limit, search);
    Axios.get(url, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(fetchChannelContractVODsSuccess(res.data && res.data.result && res.data.result.list,
                skip, limit, search, res && res.data && res.data.result && res.data.result.count));
            if (cb) {
                cb(res.data && res.data.result && res.data.result.list, res && res.data && res.data.result && res.data.result.count);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchChannelContractVODsError(message));
            if (cb) {
                cb(null);
            }
        });
};

const fetchContractInteractiveVideosInProgress = () => {
    return {
        type: FETCH_CONTRACT_INTERACTIVE_VIDEOS_IN_PROGRESS,
    };
};

const fetchContractInteractiveVideosSuccess = (value, skip, limit, search, total) => {
    return {
        type: FETCH_CONTRACT_INTERACTIVE_VIDEOS_SUCCESS,
        value,
        skip,
        limit,
        search,
        total,
    };
};

const fetchContractInteractiveVideosError = (message) => {
    return {
        type: FETCH_CONTRACT_INTERACTIVE_VIDEOS_ERROR,
        message,
    };
};

export const fetchContractInteractiveVideos = (id, skip, limit, search, cb) => (dispatch) => {
    dispatch(fetchContractInteractiveVideosInProgress());

    const url = urlFetchContractInteractiveVideos(id, skip, limit, search);
    Axios.get(url, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(fetchContractInteractiveVideosSuccess(res.data && res.data.result && res.data.result.list,
                skip, limit, search, res && res.data && res.data.result && res.data.result.count));
            if (cb) {
                cb(res.data && res.data.result && res.data.result.list, res && res.data && res.data.result && res.data.result.count);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchContractInteractiveVideosError(message));
            if (cb) {
                cb(null);
            }
        });
};

const fetchContractVideoMintsInProgress = () => {
    return {
        type: FETCH_CONTRACT_VIDEO_MINTS_IN_PROGRESS,
    };
};

const fetchContractVideoMintsSuccess = (value, skip, limit, search, total) => {
    return {
        type: FETCH_CONTRACT_VIDEO_MINTS_SUCCESS,
        value,
        skip,
        limit,
        search,
        total,
    };
};

const fetchContractVideoMintsError = (message) => {
    return {
        type: FETCH_CONTRACT_VIDEO_MINTS_ERROR,
        message,
    };
};

export const fetchContractVideoMints = (id, skip, limit, search, cb) => (dispatch) => {
    dispatch(fetchContractVideoMintsInProgress());

    const url = urlFetchContractVideoMints(id, skip, limit, search);
    Axios.get(url, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(fetchContractVideoMintsSuccess(res.data && res.data.result && res.data.result.list,
                skip, limit, search, res && res.data && res.data.result && res.data.result.count));
            if (cb) {
                cb(res.data && res.data.result && res.data.result.list, res && res.data && res.data.result && res.data.result.count);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchContractVideoMintsError(message));
            if (cb) {
                cb(null);
            }
        });
};

const fetchContractGatedIVInProgress = () => {
    return {
        type: FETCH_CONTRACT_GATED_IV_IN_PROGRESS,
    };
};

const fetchContractGatedIVSuccess = (value, skip, limit, search, total) => {
    return {
        type: FETCH_CONTRACT_GATED_IV_SUCCESS,
        value,
        skip,
        limit,
        search,
        total,
    };
};

const fetchContractGatedIVError = (message) => {
    return {
        type: FETCH_CONTRACT_GATED_IV_ERROR,
        message,
    };
};

export const fetchContractGatedIV = (id, skip, limit, search, cb) => (dispatch) => {
    dispatch(fetchContractGatedIVInProgress());

    const url = urlFetchContractGatedIV(id, skip, limit, search);
    Axios.get(url, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(fetchContractGatedIVSuccess(res.data && res.data.result && res.data.result.list,
                skip, limit, search, res && res.data && res.data.result && res.data.result.count));
            if (cb) {
                cb(res.data && res.data.result && res.data.result.list, res && res.data && res.data.result && res.data.result.count);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchContractGatedIVError(message));
            if (cb) {
                cb(null);
            }
        });
};

const fetchContractVideoDropsInProgress = () => {
    return {
        type: FETCH_CONTRACT_VIDEO_DROPS_IN_PROGRESS,
    };
};

const fetchContractVideoDropsSuccess = (value, skip, limit, search, total) => {
    return {
        type: FETCH_CONTRACT_VIDEO_DROPS_SUCCESS,
        value,
        skip,
        limit,
        search,
        total,
    };
};

const fetchContractVideoDropsError = (message) => {
    return {
        type: FETCH_CONTRACT_VIDEO_DROPS_ERROR,
        message,
    };
};

export const fetchContractVideoDrops = (id, skip, limit, search, cb) => (dispatch) => {
    dispatch(fetchContractVideoDropsInProgress());

    const url = urlFetchContractVideoDrops(id, skip, limit, search);
    Axios.get(url, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(fetchContractVideoDropsSuccess(res.data && res.data.result && res.data.result.list,
                skip, limit, search, res && res.data && res.data.result && res.data.result.count));
            if (cb) {
                cb(res.data && res.data.result && res.data.result.list, res && res.data && res.data.result && res.data.result.count);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchContractVideoDropsError(message));
            if (cb) {
                cb(null);
            }
        });
};

const fetchContractUpcomingIVInProgress = () => {
    return {
        type: FETCH_CONTRACT_UPCOMING_IV_IN_PROGRESS,
    };
};

const fetchContractUpcomingIVSuccess = (value, skip, limit, search, total) => {
    return {
        type: FETCH_CONTRACT_UPCOMING_IV_SUCCESS,
        value,
        skip,
        limit,
        search,
        total,
    };
};

const fetchContractUpcomingIVError = (message) => {
    return {
        type: FETCH_CONTRACT_UPCOMING_IV_ERROR,
        message,
    };
};

export const fetchContractUpcomingIV = (id, skip, limit, search, cb) => (dispatch) => {
    dispatch(fetchContractUpcomingIVInProgress());

    const url = urlFetchContractUpcomingIV(id, skip, limit, search);
    Axios.get(url, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(fetchContractUpcomingIVSuccess(res.data && res.data.result && res.data.result.list,
                skip, limit, search, res && res.data && res.data.result && res.data.result.count));
            if (cb) {
                cb(res.data && res.data.result && res.data.result.list, res && res.data && res.data.result && res.data.result.count);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchContractUpcomingIVError(message));
            if (cb) {
                cb(null);
            }
        });
};

export const setV2ChannelPresent = (value) => {
    return {
        type: IS_V2_CHANNEL_PRESENT,
        value,
    };
};

export const setChannelEmpty = (value) => {
    return {
        type: SET_CHANNEL_EMPTY,
        value,
    };
};

export const setChannelPageTab = (value) => {
    return {
        type: CHANNEL_PAGE_TAB_VALUE_SET,
        value,
    };
};

export const setChannelPageSubTab = (value) => {
    return {
        type: CHANNEL_PAGE_SUB_TAB_VALUE_SET,
        value,
    };
};

export const setVideosListEmpty = (value) => {
    return {
        type: SET_VIDEOS_LIST_EMPTY,
        value,
    };
};

const fetchChannelLiveStreamsInProgress = () => {
    return {
        type: FETCH_CHANNEL_LIVE_STREAMS_IN_PROGRESS,
    };
};

const fetchChannelLiveStreamsSuccess = (value, skip, limit, total) => {
    return {
        type: FETCH_CHANNEL_LIVE_STREAMS_SUCCESS,
        value,
        skip,
        limit,
        total,
    };
};

const fetchChannelLiveStreamsError = (message) => {
    return {
        type: FETCH_CHANNEL_LIVE_STREAMS_ERROR,
        message,
    };
};

export const fetchChannelLiveStreams = (contractAddress, username, skip, limit, cb) => (dispatch) => {
    dispatch(fetchChannelLiveStreamsInProgress());

    const url = urlFetchChannelLiveStreams(contractAddress, username, skip, limit);
    Axios.get(url, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(fetchChannelLiveStreamsSuccess(res.data && res.data.result && res.data.result.list,
                skip, limit, res && res.data && res.data.result && res.data.result.count));
            if (cb) {
                cb(res.data && res.data.result && res.data.result.list, res && res.data && res.data.result && res.data.result.count);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchChannelLiveStreamsError(message));
            if (cb) {
                cb(null);
            }
        });
};

// Channel Videos Stats

const fetchChannelVideosStatsInProgress = () => {
    return {
        type: FETCH_CHANNEL_VIDEOS_STATS_IN_PROGRESS,
    };
};

const fetchChannelVideosStatsSuccess = (value) => {
    return {
        type: FETCH_CHANNEL_VIDEOS_STATS_SUCCESS,
        value,
    };
};

const fetchChannelVideosStatsError = (message) => {
    return {
        type: FETCH_CHANNEL_VIDEOS_STATS_ERROR,
        message,
        variant: 'error',
    };
};

export const fetchChannelVideosStats = (id) => (dispatch) => {
    dispatch(fetchChannelVideosStatsInProgress());

    const url = urlChannelVideoStats(id);
    Axios.get(url, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(fetchChannelVideosStatsSuccess(res.data && res.data.result));
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchChannelVideosStatsError(message));
        });
};

export const setChannelIVSearch = (value) => {
    return {
        type: SET_CHANNEL_IV_SEARCH,
        value,
    };
};

export const hideDiscardChangesDialog = () => {
    return {
        type: DISCARD_CHANGES_DIALOG_HIDE,
    };
};

export const showDiscardChangesDialog = (value) => {
    return {
        type: DISCARD_CHANGES_DIALOG_SHOW,
        value,
    };
};
